<template>
  <div>
    <template v-if="mode === 'width'">
      <span ref="tooltip" v-if="!isTooltip" :style="{width:customWidth}" :class="['text',className]">{{content}}</span>
      <el-tooltip v-else class="item" effect="dark" :content="content" placement="top">
        <span :style="{width:customWidth}" :class="['text',className]">{{content}}</span>
      </el-tooltip>
    </template>
    <template v-else>
      <div v-if="content.length < setLength">
        {{content}}
      </div>
      <el-tooltip class="item" :effect="effect" :content="content" :placement="placement" v-else>
        <span class="e-pointer">{{String(content).substring(0,setLength-1)}}...</span>
      </el-tooltip>
    </template>
  </div>
</template>

<script>
  export default {
    name: 'e-tooltip',
    props: {
      placement: {
        type: String,
        default: 'top'
      },
      content: {
        type: String,
        default: ''
      },
      effect: {
        type: String,
        default: 'dark'
      },
      setLength: {
        type: Number,
        default: 10
      },
      className: {
        type: String,
        default: ''
      },
      width: {
        type: [String, Number],
        default: ''
      },
      // width:
      mode: {
        type: String,
        default: ''
      }
    },
    computed: {
      customWidth() {
        return this.width ? (this.width + 'px') : '100%';
      }
    },
    data() {
      return {
        isTooltip: false
      };
    },
    mounted() {
      if(this.mode === 'width'){
        this.isTooltip = this.$refs.tooltip.scrollWidth > this.$refs.tooltip.offsetWidth;
      }
    }
  };
</script>
<style lang="scss">
  .el-tooltip__popper {
    max-width: 400px;
  }
</style>
<style lang="scss" scoped>
  .text {
    display: inline-block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    vertical-align: middle;
  }
</style>
